const it = {
  'home.eyebrow':         '🌍 geoplay24.com',
  'home.title':           'Geo Play 24',
  'home.subtitle.line1':  '7 giochi di geografia immersivi.',
  'home.subtitle.line2':  '1 mondo. 5 livelli. Meraviglia infinita.',
  'home.tagline.line1':   'Sette giochi, un pianeta.',
  'home.tagline.line2':   'Scopri ogni angolo della Terra — competi, guadagna punti, conquista il tuo impero.',
  'home.footer.company':  'Azienda',
  'home.footer.legal':    'Legale',
  'home.footer.about':    'Chi siamo',
  'home.footer.contact':  'Contatti',
  'home.footer.github':   'GitHub',
  'home.footer.tiktok':   'TikTok',
  'home.footer.x':        'X / Twitter',
  'home.footer.privacy':  'Privacy',
  'home.footer.terms':    'Termini',
  'home.footer.cookies':  'Cookie',
  'home.copy':            'powered by: © 2026 Janek @ DevFlow C ™️',
  'home.beta.title':      'Unisciti ai primi tester della nostra app Android',
  'home.beta.text':       'Ottieni un badge Founder, Premium a vita e una chance ai premi estratti sopra.',
  'home.beta.cta':        'Programma BETA',

  'common.start':         'Avvia',
  'common.startBig':      '▶ Avvia',
  'common.back':          'Indietro',
  'common.home':          'Home',
  'common.howToPlay':     'Come si gioca',
  'common.gotIt':         'Capito — torna al gioco',
  'common.next':          'Avanti',
  'common.restart':       'Ricomincia',
  'common.tryAgain':      'Riprova',
  'common.playAgain':     'Gioca di nuovo',
  'common.mainMenu':      'Menu principale',
  'common.quit':          'Esci',
  'common.play':          'Gioca',
  'common.unlock':        '🔒 Sblocca con Premium',
  'common.language':      'Lingua',

  'rules.kicker.goal':         'Obiettivo',
  'rules.kicker.howToPlay':    'Come si gioca',
  'rules.kicker.levels':       'Livelli',
  'rules.kicker.tips':         'Consigli',
  'rules.gameNotFound':        'Gioco non trovato',
  'rules.points':              'pti',

  'games.origin.title':       'Origin Hunt',
  'games.origin.tagline':     'Trova le tue radici',
  'games.origin.description': 'Una posizione casuale di Street View nel mondo. Indica il punto sulla mappa. Precisione 100 km → 1 km in 5 livelli.',
  'games.hunt.title':         'Object Hunt',
  'games.hunt.tagline':       'Caccia al tesoro stile GPS',
  'games.hunt.description':   'Atterri vicino a un monumento reale. Cammina in Street View fino a trovarlo. La bussola diventa sempre meno utile.',
  'games.photo.title':        'Photo Detective',
  'games.photo.tagline':      'Leggi gli indizi',
  'games.photo.description':  'Un singolo scatto Street View — niente panoramica, niente movimento. Leggi cartelli, piante, posizione del sole. Da 30 sec a un lampo di 5 sec.',
  'games.pangaea.title':      'Pangaea Puzzle',
  'games.pangaea.tagline':    'Riassembla la Terra',
  'games.pangaea.description':'Continenti e isole fluttuano attorno a un globo 3D. Riportali al loro posto — posizione attuale o l\'antica Pangea.',

  'rules.origin.goal': 'Vieni catapultato in uno Street View casuale sulla Terra. Posizionati sulla mappa del mondo con la massima precisione.',
  'rules.origin.step1': 'Guarda il panorama. Leggi cartelli, conta le corsie, osserva il sole.',
  'rules.origin.step2': 'Clicca sulla minimappa per piazzare un pin.',
  'rules.origin.step3': 'Conferma. Più il pin è vicino al punto reale, più punti.',
  'rules.origin.step4': 'I livelli si concatenano — supera la soglia di distanza per sbloccare il successivo.',
  'rules.origin.level1': 'entro 100 km',
  'rules.origin.level2': 'entro 50 km',
  'rules.origin.level3': 'entro 25 km',
  'rules.origin.level4': 'entro 10 km',
  'rules.origin.level5': 'entro 1 km',
  'rules.origin.tip1': 'Senso di marcia, formato targa e colore della segnaletica tradiscono in fretta il paese.',
  'rules.origin.tip2': 'Vegetazione + altezza del sole restringono la latitudine. I cartelli stradali fissano la città.',
  'rules.origin.tip3': 'Il Master Geographer (L5 = 1 km) è brutale — quasi tutti i run finiscono a L3 o L4.',

  'rules.hunt.goal': 'Vieni piazzato in Street View vicino a un monumento reale. Cammina nel panorama fino a starci sopra. La bussola aiuta sempre meno.',
  'rules.hunt.step1': 'Leggi il nome del bersaglio nella barra in alto.',
  'rules.hunt.step2': 'Usa la freccia della bussola + distanza per orientarti.',
  'rules.hunt.step3': 'Clicca sui chevron per camminare in Street View.',
  'rules.hunt.step4': 'Dentro la zona di ricerca, il pulsante "Trovato!" si attiva — premilo per fare punti.',
  'rules.hunt.level1': '5 km · 10 min · famoso al mondo · freccia + distanza esatta · zona 100 m',
  'rules.hunt.level2': '15 km · 12 min · famoso al mondo · freccia + distanza arrotondata',
  'rules.hunt.level3': '25 km · 12 min · noto nel paese · solo bussola, senza distanza',
  'rules.hunt.level4': '50 km · 15 min · noto nel paese · indicatore caldo/freddo',
  'rules.hunt.level5': '50 km · 10 min · oscuro · solo il nome, senza GPS',
  'rules.hunt.tip1': 'A L4–L5 hai 3 Compass Ping — lampi della freccia, usali con cautela.',
  'rules.hunt.tip2': 'Bonus a metà strada: superare la metà aggiunge 2 minuti.',
  'rules.hunt.tip3': 'Se hai solo il nome, scava in memoria o osserva i dintorni — molti monumenti sono riconoscibili da lontano.',

  'rules.photo.goal': 'Vedi un singolo fotogramma Street View — niente panoramica, niente movimento. Da cartelli, piante, sole e segnaletica deduci il luogo.',
  'rules.photo.step1': 'Scegli prima una regione (Mondo, Europa, Asia…) — definisce il pagliaio.',
  'rules.photo.step2': 'La foto lampeggia per un tempo fisso. Sfrutta ogni secondo.',
  'rules.photo.step3': 'Allo scadere appare una mappa. Piazza il tuo miglior pin.',
  'rules.photo.step4': 'Pin più vicino = più punti. La schermata risultati ripete la foto.',
  'rules.photo.level1': '30 sec di osservazione · precisione 1 000 km',
  'rules.photo.level2': '20 sec · 500 km',
  'rules.photo.level3': '15 sec · 250 km',
  'rules.photo.level4': '10 sec · 100 km',
  'rules.photo.level5': 'lampo 5 sec · 50 km',
  'rules.photo.tip1': 'La lingua sui cartelli è l\'indizio più rapido. Una sola parola spesso fissa il paese.',
  'rules.photo.tip2': 'La direzione del sole indica il sud (emisfero nord) o il nord (emisfero sud).',
  'rules.photo.tip3': 'Forma dei pali, segnaletica orizzontale e targhe sono sorprendentemente diagnostici.',

  'rules.pangaea.goal': 'Una Terra 3D, sei continenti. Piazzane ognuno entro la tolleranza angolare del livello — posizione moderna o quella di 300 milioni di anni fa in Pangea.',
  'rules.pangaea.step1': 'Scegli un continente dalla lista a destra.',
  'rules.pangaea.step2': 'Clicca sul globo dove pensi vada.',
  'rules.pangaea.step3': 'Entro tolleranza → scatta in posizione. Altrimenti → feedback rosso, riprova.',
  'rules.pangaea.step4': '3 tentativi per continente. Almeno 5 su 6 per avanzare.',
  'rules.pangaea.level1': 'Continenti · oggi · tolleranza 25°',
  'rules.pangaea.level2': 'oggi · tolleranza 18°',
  'rules.pangaea.level3': 'oggi · 12° preciso',
  'rules.pangaea.level4': 'Pangea · antico · tolleranza 25°',
  'rules.pangaea.level5': 'Pangea · antico · 18° preciso',
  'rules.pangaea.tip1': 'Trascina il globo per ruotare. Scrolla per zoomare.',
  'rules.pangaea.tip2': 'In Pangea i continenti erano raggruppati a sud — Africa e Sud America combaciavano, India contro l\'Africa orientale, Nord America contro l\'Europa.',
  'rules.pangaea.tip3': 'L\'Antartide stava più o meno all\'equatore. L\'Australia ci stava aggrappata sotto.',

  /* ─── Landmark Quiz ─── */
  'games.landmark.title':          'Landmark Quiz',
  'games.landmark.tagline':        'Riconosci il monumento',
  'games.landmark.description':    'Una foto di un edificio o monumento famoso — riconoscilo e piazza un pin sulla mappa del mondo.',
  'rules.landmark.goal':           'Vedi la foto di un monumento famoso. Piazza un pin sulla mappa del mondo dove pensi si trovi.',
  'rules.landmark.step1':          'Guarda la foto qualche secondo. Riconosci l\'edificio, leggi il contesto.',
  'rules.landmark.step2':          'A fine timer compare la mappa.',
  'rules.landmark.step3':          'Piazza un pin e invia. Più vicino = più punti.',
  'rules.landmark.step4':          'Cinque livelli. Ognuno più breve e più stretto del precedente.',
  'rules.landmark.level1':         '30 sec di osservazione · precisione 1 000 km',
  'rules.landmark.level2':         '20 sec · 500 km',
  'rules.landmark.level3':         '15 sec · 250 km',
  'rules.landmark.level4':         '10 sec · 100 km',
  'rules.landmark.level5':         'lampo di 5 sec · 50 km',
  'rules.landmark.tip1':           'Forme inconfondibili (Eiffel, piramidi) si riconoscono al volo — i punti vengono dal pin preciso.',
  'rules.landmark.tip2':           'Monumenti meno noti: leggi il contesto — clima, architettura, dintorni.',
  'rules.landmark.tip3':           'Foto da Wikipedia con licenza CC-BY-SA. Tocca il credito per la fonte.',

  'paywall.title':        "Questo gioco è Premium",
  'paywall.text':         "Sblocca questo gioco con i punti che guadagni giocando.",
  'paywall.cta':          "Unisciti al programma BETA",
  'paywall.dismiss':      "Magari dopo",

  /* ─── Spot the Landmark ─── */
  'games.spot.title':       "Spot the Landmark",
  'games.spot.tagline':     "Risposta multipla",
  'games.spot.description': "Foto di un edificio o monumento famoso — scegli la risposta giusta tra 3-6 opzioni. Modalità infinita, più dura a ogni round.",

  'rules.spot.goal':   "Guarda la foto, scegli il monumento giusto. Una risposta sbagliata finisce la corsa.",
  'rules.spot.step1':  "Scegli una regione (Mondo, Europa, Asia…) — il pool si filtra sul continente.",
  'rules.spot.step2':  "Appare una foto di monumento famoso con una domanda.",
  'rules.spot.step3':  "Tocca la risposta giusta tra le opzioni.",
  'rules.spot.step4':  "Tieni viva la striscia — ogni livello aggiunge una scelta (max 6) e diventa più duro.",
  'rules.spot.level1': "L1–L3 · 3–5 scelte · solo il nome",
  'rules.spot.level2': "L4+ · 6 scelte · solo il nome",
  'rules.spot.level3': "L10+ · 6 scelte · nome + paese",
  'rules.spot.level4': "L20+ · 6 scelte · nome + città + paese",
  'rules.spot.level5': "Infinito · il punteggio scala con la profondità · un errore finisce tutto",
  'rules.spot.tip1':   "I distrattori vengono dallo stesso continente — leggi bene.",
  'rules.spot.tip2':   "Forme iconiche (Eiffel, piramidi) sono facili — i punti vengono dalla profondità.",
  'rules.spot.tip3':   "Dal L10 si aggiunge il paese; dal L20 la città.",

  "spot.region.title": "Dove vuoi giocare?",
  "spot.region.sub": "Scegli una regione. Appariranno monumenti famosi — scegli la risposta giusta.",
  "spot.q.name": "Che monumento è?",
  "spot.q.namecountry": "Nome + paese?",
  "spot.q.namecity": "Nome + città + paese?",
  "spot.score": "Punteggio",
  "spot.choices": "scelte",
  "spot.correct": "CORRETTO",
  "spot.wrong": "SBAGLIATO",
  "spot.points": "PUNTI",
  "spot.runTotal": "Totale run",
  "spot.next": "Avanti →",
  "spot.youPicked": "Hai scelto",
  "spot.finalScore": "PUNTEGGIO FINALE",
  "spot.reachedLevel": "Hai raggiunto il livello",
  "spot.tryAgain": "Riprova ↺",
  "spot.changeRegion": "Cambia regione",
  "spot.mainMenu": "Menu principale",

  /* ─── Auth ─── */
  "auth.signIn": "Accedi",
  "auth.eyebrow": "MINDFUL ZEN WORLD",
  "auth.title": "Accedi o crea un account",
  "auth.subtitle": "Niente password — ti mandiamo un link magico via email. Nuovo? Account creato al volo.",
  "auth.send": "Invia link",
  "auth.sending": "Invio…",
  "auth.invalidEmail": "Inserisci un'email valida.",
  "auth.sendFailed": "Impossibile inviare il link. Riprova.",
  "auth.checkInbox": "Controlla la posta",
  "auth.linkSentTo": "Un link di accesso sta arrivando a",
  "auth.spamHint": "Non lo trovi? Guarda nello spam. Il link scade in 1 ora.",
  "auth.gotIt": "OK",
  "auth.fineprint": "Continuando accetti i nostri Termini e l'Informativa Privacy.",
  "auth.menu.profile": "Profilo",
  "auth.menu.admin": "Admin",
  "auth.menu.signOut": "Esci",
  "auth.callback.signingIn": "Accesso in corso…",
  "auth.callback.hold": "Un attimo.",
  "auth.callback.welcome": "Benvenuto",
  "auth.callback.redirecting": "Ti porto ai giochi…",
  "auth.callback.problem": "Qualcosa è andato storto",

  /* ─── Auth ─── */

  /* ─── Profile ─── */
  "profile.title": "Il mio Profilo",
  "profile.totalPoints": "Punti totali",
  "profile.totalRuns": "Partite giocate",
  "profile.gamesPlayed": "Giochi provati",
  "profile.editTitle": "Modifica profilo",
  "profile.displayName": "Nome visualizzato",
  "profile.avatar": "Avatar",
  "profile.country": "Paese (opzionale)",
  "profile.countryHint": "Codice ISO a 2 lettere, es. IT, US, JP. Per bandiere classifica.",
  "profile.save": "Salva",
  "profile.saving": "Salvataggio…",
  "profile.saved": "Salvato",
  "profile.nameTooShort": "Il nome deve avere almeno 2 caratteri.",
  "profile.perGame": "Miglior per gioco",
  "profile.noRuns": "Ancora nessuna partita — torna al menu e scegli un gioco.",

  /* ─── Profile ─── */

  /* ─── Gating + Anon limit ─── */
  "common.locked": "BLOCCATO",
  "common.needPoints": "SERVONO {n} PT",
  "locked.pill": "BLOCCATO",
  "locked.title": "{game} è bloccato",
  "locked.text": "Ti mancano {remaining} punti per sbloccare {game}. Continua con i giochi disponibili.",
  "locked.dismiss": "OK",
  "spot.anon.playsLeft": "{n} partite gratis rimaste — accedi per continuare.",
  "spot.anon.title": "Hai usato le partite gratuite",
  "spot.anon.text": "Hai giocato {used} su {limit} partite gratis. Accedi per continuare — gratis, senza password, solo un link via email.",
  "spot.anon.signIn": "Accedi →",
  "spot.anon.back": "Torna al menu",

  /* ─── Gating + Anon limit ─── */

  /* ─── Next game banner ─── */
  "rules.next.upcoming": "PROSSIMO",
  "rules.next.unlocked": "PROSSIMO — SBLOCCATO",
  "rules.next.unlockedHint": "Hai abbastanza punti — torna al menu e gioca.",
  "rules.next.needMore": "{remaining} pt per sbloccare — continua a giocare.",
  "rules.next.signedOut": "Guadagna {threshold} punti per sbloccare — accedi per iniziare a contare.",
  "rules.next.premiumHint": "Sbloccato con Premium — arriva con la beta Android.",

  /* ─── Next game banner ─── */

  /* ─── Audio Atlas ─── */
  'games.audio.title':       "Audio Atlas",
  'games.audio.tagline':     "Bandiera + inno",
  'games.audio.description': "Suona un inno nazionale e vedi la bandiera. Pianta un pin sulla capitale.",

  'rules.audio.goal':   "Senti un inno nazionale e vedi la bandiera. Pianta un pin sulla capitale — il più preciso possibile.",
  'rules.audio.step1':  "Scegli una regione. Il pool si filtra sul continente.",
  'rules.audio.step2':  "L\'inno parte automaticamente. La bandiera resta visibile.",
  'rules.audio.step3':  "Allo zero, appare la mappa. Pianta il pin sulla capitale.",
  'rules.audio.step4':  "Passi se sei nella soglia. Più alto = ascolto più corto.",
  'rules.audio.level1': "10 sec · ≤ 1 000 km",
  'rules.audio.level2': "8 sec · 500 km",
  'rules.audio.level3': "6 sec · 250 km",
  'rules.audio.level4': "4 sec · 100 km",
  'rules.audio.level5': "Flash 3 sec · 50 km",
  'rules.audio.tip1':   "La lingua è l'indizio più veloce — una parola spesso basta.",
  'rules.audio.tip2':   "Alcune capitali non sono la città più grande (Brasília, Canberra, Ottawa, Pretoria).",
  'rules.audio.tip3':   "Tempo e strumenti dell\'inno aiutano se la bandiera è ignota.",

  "audio.region.title": "Dove vuoi ascoltare?",
  "audio.region.sub": "Scegli una regione. Sentirai un inno nazionale e vedrai la bandiera del paese — pianta un pin sulla capitale.",
  "audio.empty.title": "Nessun clip audio ancora",
  "audio.empty.text": "Ancora nessun inno disponibile — stiamo curando la selezione. Torna presto per identificare nuovi paesi.",
  "audio.listen.hint": "Riconosci bandiera e inno? Pianta il pin sulla capitale.",
  "audio.listen.skip": "Ne ho abbastanza →",
  "audio.submit.ready": "Invia →",
  "audio.submit.empty": "Clicca sulla mappa per piantare un pin",
  "audio.changeRegion": "Cambia regione",

  /* ─── Empire ─── */
  "profile.empire.title": "Il mio Impero",
  "profile.empire.empty": "Identifica un paese in Audio Atlas o Landmark Quiz per conquistarlo. Il tuo impero cresce con ogni risposta giusta.",

  /* ─── Empire ─── */

  /* ─── Boost / Shop ─── */
  "boost.title": "Salta il grind",
  "boost.tagline": "Compra punti, sblocca più veloce",
  "boost.description": "Non vuoi aspettare? Tre pacchetti da €2.99. I punti arrivano subito e contano per ogni sblocco.",
  "boost.cta": "Compra punti",
  "shop.title": "Negozio punti",
  "shop.sub": "Salta il grind",
  "shop.buy": "Compra",
  "shop.opening": "Apertura…",
  "shop.success": "Pagamento confermato — punti accreditati in pochi secondi.",
  "shop.cancel": "Checkout annullato — nessun addebito.",
  "shop.fineprint": "Acquisto singolo via Stripe. I punti arrivano dopo la conferma. Nessun abbonamento.",
  "shop.boost.badge": "Popolare",
  "shop.power.badge": "Miglior offerta",

  /* ─── Boost / Shop ─── */
};

export default it;
